<script lang="ts">
  /**
   * Inline stroke icons, in the Lucide idiom the rest of the DSI suite uses (the Nexus
   * drive app depends on lucide-react). Inlined rather than pulled from a package: five
   * icons is not worth a dependency, and an offline-first app should not fetch glyphs.
   */
  interface Props { name: IconName; size?: number; }
  let { name, size = 18 }: Props = $props();

  export type IconName =
    | 'scan' | 'cart' | 'warehouse' | 'chart' | 'settings'
    | 'tag' | 'download' | 'plus' | 'search' | 'check' | 'alert' | 'refresh';

  const paths: Record<IconName, string[]> = {
    scan: ['M3 7V5a2 2 0 0 1 2-2h2', 'M17 3h2a2 2 0 0 1 2 2v2', 'M21 17v2a2 2 0 0 1-2 2h-2',
           'M7 21H5a2 2 0 0 1-2-2v-2', 'M7 12h10'],
    cart: ['M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12'],
    warehouse: ['M22 8.35V20a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z',
                'M6 18h12', 'M6 14h12'],
    chart: ['M3 3v18h18', 'M18 17V9', 'M13 17V5', 'M8 17v-3'],
    settings: ['M21 4H14', 'M10 4H3', 'M21 12H12', 'M8 12H3', 'M21 20H16', 'M12 20H3',
               'M14 2v4', 'M8 10v4', 'M16 18v4'],
    tag: ['M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z'],
    download: ['M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4', 'M7 10l5 5 5-5', 'M12 15V3'],
    plus: ['M5 12h14', 'M12 5v14'],
    search: ['M11 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16z', 'M21 21l-4.3-4.3'],
    check: ['M20 6 9 17l-5-5'],
    alert: ['M12 9v4', 'M12 17h.01',
            'M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z'],
    refresh: ['M3 12a9 9 0 0 1 9-9 9 9 0 0 1 6.36 2.64L21 8', 'M21 3v5h-5',
              'M21 12a9 9 0 0 1-9 9 9 9 0 0 1-6.36-2.64L3 16', 'M3 21v-5h5'],
  };

  const circles: Partial<Record<IconName, [number, number, number][]>> = {
    cart: [[8, 21, 1], [19, 21, 1]],
  };
</script>

<svg
  width={size} height={size} viewBox="0 0 24 24"
  fill="none" stroke="currentColor" stroke-width="1.75"
  stroke-linecap="round" stroke-linejoin="round"
  aria-hidden="true" focusable="false"
  style="flex:none"
>
  {#each paths[name] as d (d)}<path {d} />{/each}
  {#each circles[name] ?? [] as [cx, cy, r] (`${cx}-${cy}`)}<circle {cx} {cy} {r} fill="currentColor" stroke="none" />{/each}
</svg>
